<template>
  <component :is="routeLayout" v-if="!route.meta?.error" :title="route.meta?.title" :path="route.meta?.path">
    <RouterView v-slot="{ Component, route: activeRoute }">
      <component :is="Component" :key="activeRoute.path" />
    </RouterView>
    <template v-if="route.meta?.extraContent" #extra-content><component :is="route.meta.extraContent" /></template>
  </component>
  <ErrorPage v-else :error="route.meta?.error" />
</template>

<script setup lang="ts">
import Page from "@/components/page/Page.vue";
import ErrorPage from "@/pages/ErrorPage.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";
import EmptyLayout from "./EmptyLayout.vue";

const route = useRoute();

const routeLayout = computed(() => {
  if (route.meta.layout) return route.meta.layout;

  if (route.meta.layout == false) return EmptyLayout;

  //return default layout
  return Page;
});
</script>
